import { useFormContext, useController } from 'react-hook-form';
import { UncontrolledInput } from 'components/Form';
import serialize from 'utils/serialize';

import { defaultDetail } from './VenueDetail';
import { useCallback } from 'react';

const parseGoogleURL = (lat, lng) => {
  const params = {
    api: 1,
    query: `${lat},${lng}`,
  };
  return `https://www.google.com/maps/search/?${serialize(params)}`;
};

const latitudeRegExp = /^(\+|-)?(?:90(?:(?:\.0{6,}))|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{6,})))$/;
const longitudeRegExp =
  /^(\+|-)?(?:180(?:(?:\.0{6,}))|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{6,})))/;

const latLngRules = (name, pattern) => ({
  required: `${name} is required`,
  pattern: {
    value: pattern,
    message: `${name} wrong format`,
  },
});

const VenuePositionEditMode = ({ position, error, fieldName }) => {
  const { field: latField } = useController({
    name: `${fieldName}.lat`,
    defaultValue: position?.lat || '',
    shouldUnregister: false,
    rules: latLngRules('Latitude', latitudeRegExp),
  });

  const { field: lngField } = useController({
    name: `${fieldName}.lng`,
    defaultValue: position?.lng || '',
    shouldUnregister: false,
    rules: latLngRules('Longitude', longitudeRegExp),
  });

  const { setValue } = useFormContext();

  const handlePaste = useCallback(
    (e) => {
      const pastedValue = e.clipboardData.getData('Text');
      const splitted = pastedValue.split(', ');
      if (splitted.length < 2) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();

      setValue(`${fieldName}.lat`, splitted[0]);
      setValue(`${fieldName}.lng`, splitted[1]);
    },
    [fieldName, setValue]
  );

  return (
    <div className="field-container half-fields">
      <div>
        <UncontrolledInput
          className="input"
          placeholder="Latitude"
          hasError={!!error?.lat?.message}
          onPaste={handlePaste}
          {...latField}
        />
        {!!error?.lat?.message && <div className="field-error">{error?.lat?.message}</div>}
      </div>
      <div>
        <UncontrolledInput
          className="input"
          placeholder="Longitude"
          hasError={!!error?.lng?.message}
          {...lngField}
        />
        {!!error?.lng?.message && <div className="field-error">{error?.lng?.message}</div>}
      </div>
    </div>
  );
};

const VenuePositionRenderer = ({ value: position, fieldName, isEditing, error }) => {
  const { lat, lng } = position || {};

  if (isEditing) {
    return <VenuePositionEditMode position={position} fieldName={fieldName} error={error} />;
  }

  if (!lat || !lng) {
    return <>{defaultDetail}</>;
  }

  return (
    <a href={parseGoogleURL(lat, lng)} target="_blank" rel="nofollow noreferrer" className="link">
      {lat}, {lng}
    </a>
  );
};

export default VenuePositionRenderer;
